module.exports = __webpack_public_path__ + "img/teacher-tip.b694cb28.png";